export const SET_AUTHENTICATED = 'setAuthenticated'
export const SET_KAS_CONFIGURATION_SETTINGS = 'setKasConfigurationSettings'
export const SET_LOGIN_CONTEXT = 'setUserTokenExpiration'
export const SET_LOGIN_FORM_URL = 'setLoginFormUrl'
export const SET_LOGIN_SYNC_URL = 'setLoginSyncUrl'
export const SET_LOGOUT_SYNC_URL = 'setLogoutSyncUrl'
export const SET_RAW_USER_INFOS = 'setRawUserInfos'
export const SET_REFRESH_SYNC_URL = 'setRefreshSyncUrl'
export const SET_SHOW_ACCOUNT_NAV = 'setShowAccountNav'
export const SET_UNREGISTER_SYNC_URL = 'setUnregisterSyncUrl'
export const SET_USER_INFOS = 'setUserInfos'
export const SET_USER_STATUS_SYNC_URL = 'setUserStatusSyncUrl'
export const SET_USER_TOKEN = 'setUserToken'
